const loginstyles = {
    gridContainer:{
      height: 'auto',
      position: 'absolute',
      top: '20%',
      left: 0,
      right: 0,
      margin: 'auto'
    },
    leftBoxContainer:{
      background: '#02ABCA',
      color: 'white'
    },
    leftCardTextTitle: {
      background: 'inherit',
      color: 'inherit',
      paddingLeft: 50,
      paddingRight: 50
    },
    leftCardTextContent: {
      background: 'inherit',
      color: 'inherit',
      paddingLeft: 33,
      paddingRight: 33
    },
    h1: {
      fontSize: 40,
      lineHeight: '50px'
    },
    h2: {
      fontSize: 30,
      lineHeight: '40px'
    },
    leftCardContainer:{
      border: 0,
      boxShadow:0,
      background: 'inherit',
      color: 'inherit',
      minHeight: 450
    },
    rightCardContainer:{
      minHeight: 450
    },
    paper: {
      padding: 20,
      overflow: 'auto',
      border: 0,
      boxShadow:0,
    },
    loginBtn: {
      float: 'right'
    },
    calAmpMediaCard: {
      margin: 'auto',
      width: '60%',
      padding: 30
    },
    buttonContainer:{
      paddingTop: 20
    },
    footer: {
      textAlign: 'center',
      color: 'grey',
      padding: 1
    }

};

export default loginstyles;



// WEBPACK FOOTER //
// ./src/components/login/styles/LoginFormStyles.js